<script setup lang="ts">

const props = defineProps<{ title: string, extraClass: string, enabled:boolean }>();

</script>

<template>
  <div :class="['container-block','button_container',props.extraClass]">
    <div>
      <button id="connectBtn" class="button" :disabled="!enabled">{{ props.title }}</button>
    </div>
  </div>
</template>

<style scoped>

</style>
